import { Component } from '@angular/core';
import { ApiMaintenanceService } from '../../../../../../libs/api/src/lib/maintenance';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class AppMaintenanceComponent {
  constructor(private _apiMaintenance: ApiMaintenanceService) {}

  get enabledStrict() {
    return this._apiMaintenance.enabledStrict;
  }

  get title() {
    return this._apiMaintenance.title;
  }

  get content() {
    return this._apiMaintenance.content;
  }

  close() {
    window.close();
  }
}
